export default __webpack_public_path__ + "static/media/graphics2.774354ad.svg";